import { render, staticRenderFns } from "./zhinengjiance.vue?vue&type=template&id=31a06bc6&scoped=true&"
import script from "./zhinengjiance.vue?vue&type=script&lang=ts&"
export * from "./zhinengjiance.vue?vue&type=script&lang=ts&"
import style0 from "./zhinengjiance.vue?vue&type=style&index=0&id=31a06bc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a06bc6",
  null
  
)

export default component.exports